import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Application',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Application',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Application',
    column_type: 'datetime',
  },
  name: {
    model_name: 'Application',
    column_type: 'string',
  },
  desc: {
    model_name: 'Application',
    column_type: 'string',
  },
  share_desc: {
    model_name: 'Application',
    column_type: 'string',
  },
  share_title: {
    model_name: 'Application',
    column_type: 'string',
  },
  wechat_application: {
    model_name: 'Application',
    column_type: 'belongs_to',
    extra: {
      association_name: 'wechat_application',
      model_name: 'BsWechatMiniProgram::Application',
    },
  },
  wechat_application_id: {
    model_name: 'Application',
    column_type: 'belongs_to',
    extra: {
      association_name: 'wechat_application',
      model_name: 'BsWechatMiniProgram::Application',
    },
  },
  application_admin_users_role_id: {
    model_name: 'Application',
    column_type: 'string',
  },
  share_image: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  logo: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  image_generate_options: {
    model_name: 'Application',
    column_type: 'string',
  },
  creator: {
    model_name: 'Application',
    column_type: 'belongs_to',
    extra: {
      association_name: 'creator',
      model_name: 'AdminUser',
    },
  },
  creator_id: {
    model_name: 'Application',
    column_type: 'belongs_to',
    extra: {
      association_name: 'creator',
      model_name: 'AdminUser',
    },
  },
  poster_image: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  login_video: {
    model_name: 'Application',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
